var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopHeader'),_c('NavBar'),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path + _vm.$route.query.t}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path + _vm.$route.query.t}):_vm._e(),_c('Footer'),(!(_vm.authRes && Object.keys(_vm.authRes).length))?_c('ContactUs'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }